<div class="iconbox" [class]="class">
  <div class="iconbox-icon">
    <img src="{{ icon }}" [style]="imgStyle"
      width="88" />
  </div>
  <div class="iconbox-content" [style]="divStyle">
    <h3 class="iconbox-content-title">{{ heading }}</h3>
    <p class="iconbox-content-desc"> {{ description }}</p>
  </div>
</div>
